import { createSelector } from '@reduxjs/toolkit';
import { ParameterState } from 'ducks/parameter/slices';
import { RootState } from 'store';

const parameterSlice = (state: RootState) => state.parameter;

export const selectParameter = createSelector([parameterSlice], (state): ParameterState => state);
